<template>
    <fts-modal :append-to-body="appendToBody" :width="width" :full-screen="fullScreen" :escape-event="escapeEvent"
        :backdrop="backdrop" :persistent="persistent" :header="isHeader" :footer="isFooter"
        :append-container-class="getContainerClass" :header-class="getHeaderClass" :content-class="getContentClass"
        :footer-class="getFooterClass" class="fts-modal-lite" @opened="$emit('opened')" @close="beforeClose"
        @focus="$emit('focus')" @blur="$emit('blur')" v-if="showDialog">


        <slot slot="header" name="header">
            <div>
                <slot name="title">
                    <div class="modal-lite-title" v-if="isTitle">
                        {{ title }}
                    </div>
                </slot>

                <slot name="description">
                    <div class="modal-lite-description" v-if="isDescription">
                        {{ description }}
                    </div>
                </slot>
            </div>

            <div class="modal-lite-header-close" :class="{ 'disabled': disableClose }" @click="beforeClose"
                v-if="!disableHeaderClose">
                <font-awesome-icon :icon="['fas', 'xmark']" fixed-width />
            </div>
        </slot>

        <slot slot="body" name="body">
        </slot>

        <slot slot="footer" name="footer">
            <div class="modal-lite-footer-l" v-if="isFooterLeft">
                <slot name="footerLeft" />
            </div>
            <div class="modal-lite-footer-r" v-if="isFooterRight">
                <slot name="footerRight" />
            </div>
        </slot>
    </fts-modal>
</template>

<script>
import FTSModal from '../elements/FTSModal.vue';

export default {
    components: {
        'fts-modal': FTSModal
    },
    props: {
        appendToBody: Boolean,
        width: String,
        fullScreen: Boolean,
        backdrop: {
            type: Boolean,
            default: true,
        },
        escapeEvent: Boolean,
        persistent: Boolean,
        appendContainerClass: String,
        appendHeaderClass: String,
        appendContentClass: String,
        appendFooterClass: String,
        title: String,
        description: String,
        disableHeaderClose: Boolean,
        disableClose: Boolean
    },
    data: () => ({
        showDialog: false,
        beforeCloseHandler: null
    }),
    methods: {
        show(item) {
            if (item && item.beforeCloseHandler) {
                this.beforeCloseHandler = item.beforeCloseHandler;
            }
            this.showDialog = true;
        },
        beforeClose() {
            if (this.disableClose) return;

            if (this.beforeCloseHandler && typeof this.beforeCloseHandler === 'function') {
                this.beforeCloseHandler();
            } else {
                this.close();
            }
        },
        close() {
            this.showDialog = false;
            this.$emit("closed");
        },
    },
    computed: {
        isTitle() {
            return (
                Boolean(this.title) ||
                Boolean(this.$slots.title) ||
                Boolean(this.$scopedSlots.title)
            );
        },
        isDescription() {
            return (
                Boolean(this.description) ||
                Boolean(this.$slots.description) ||
                Boolean(this.$scopedSlots.description)
            );
        },
        isHeader() {
            return (
                this.isTitle ||
                this.isDescription ||
                Boolean(this.$slots.header) ||
                Boolean(this.$scopedSlots.header)
            );
        },
        isFooterLeft() {
            return Boolean(this.$slots.footerLeft) || Boolean(this.$scopedSlots.footerLeft);
        },
        isFooterRight() {
            return Boolean(this.$slots.footerRight) || Boolean(this.$scopedSlots.footerRight);
        },
        isFooter() {
            return (
                this.isFooterLeft ||
                this.isFooterRight ||
                Boolean(this.$slots.footer) ||
                Boolean(this.$scopedSlots.footer)
            );
        },
        getContainerClass() {
            let classes = "modal-lite__container";
            if (this.appendContainerClass)
                classes += ` ${this.appendContainerClass}`
            return classes;
        },
        getHeaderClass() {
            let classes = "modal-lite__header";
            if (this.appendHeaderClass)
                classes += ` ${this.appendHeaderClass}`
            return classes;
        },
        getContentClass() {
            let classes = "modal-lite__content";
            if (this.appendContentClass)
                classes += ` ${this.appendContentClass}`
            return classes;
        },
        getFooterClass() {
            let classes = "modal-lite__footer";
            if (this.appendFooterClass)
                classes += ` ${this.appendFooterClass}`
            return classes;
        }
    }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-modal.fts-modal-lite {

    > .fts-modal-wrapper {

        > .fts-modal-container.modal-lite__container {
            border-radius: 0.5rem;
        }

        .modal-lite__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px;
            text-align: left;
            border-bottom: 1px solid var(--inistate-color-neutral-100);
        }

        .modal-lite__content {
            padding: 24px;
        }

        .modal-lite__footer {
            display: flex;
            padding: 0 24px 24px;
        }

        .modal-lite-footer-l {
            @include flex-gap($gap: 0.375rem);
        }

        .modal-lite-footer-r {
            @include flex-gap($gap: 0.375rem);
            justify-content: flex-end;
            flex: 1;
        }

        .modal-lite-title {
            font-weight: 500;
            font-size: 1.5rem;
            line-height: 1.75rem;
            color: var(--fts-text);

            &+.modal-lite-description {
                margin-top: 0.5rem;
            }
        }

        .modal-lite-description {
            font-size: 1rem;
            line-height: 1.5rem;
            color: var(--fts-default);
        }

        .modal-lite-header-close {
            padding: 8px;
            border-radius: 4px;
            right: 35px;
            color: var(--inistate-text-secondary);

            &:hover {
                background: var(--fts-gray-50);
                color: var(--inistate-text-primary);
                cursor: pointer;
            }

            &.disabled {
                color: var(--fts-default);
                cursor: not-allowed;
            }
        }
    }
}
</style>